export default {
  "sm": { size: 30, borderRadius: 8, fontSize: 0.8 },
  "md": { size: 60, borderRadius: 12, fontSize: 1.2 },
  "lg": { size: 60, borderRadius: 12, fontSize: 1.2 },
};
